<template>
  <div>
    <p class="widget-welcome-step_title" :class="componentStyles?.title || ''">
      {{ stepForm.schema.properties?.welcomeStep?.title }}
    </p>
    <FormRenderer
      :title="String(stepForm.schema.properties?.welcomeStep?.title)"
      :schema="stepForm?.schema"
      :uischema="stepForm?.uischema"
      :options="stepForm.options"
      class="h-full w-full"
      :is-back-button-visible="false"
      freeze-update
    ></FormRenderer>
    <WButton type="primary" class="widget-form-renderer_submit widget-welcome-step_submit" @click="emit('next')">
      {{ stepForm.options.actionLabel || 'Go' }}
      <WidgetIcon
        v-if="checkTheme('suzuki') && themeIcons.arrowRight"
        :icon="themeIcons.arrowRight"
        height="1.75rem"
        class="!transition-none !delay-0"
      />
    </WButton>
  </div>
</template>

<script lang="ts" setup>
  import { StepForm } from 'src/types/widget';
  import FormRenderer from './FormRenderer.vue';
  import WButton from 'components/base/Button.vue';
  import WidgetIcon from 'src/components/base/WidgetIcon.vue';
  import { checkTheme, getComponentStyle, themeIcons } from 'src/utils/config';

  defineProps<{
    stepForm: StepForm;
  }>();
  const emit = defineEmits<{
    (e: 'next'): void;
  }>();

  const componentStyles = getComponentStyle();
</script>

<style scoped></style>
